import { ApiService } from '../Services/ApiService';

/**
 * Tracks click events on webinar action links (preview link, full link, lecture note, etc.).
 * Scoped to any `[data-webinar-actions]` container so it works for both the agenda list view
 * and the GX search result overlay.
 */
export class ClickCounter {
    constructor() {
        this.api = new ApiService();

        jQuery('[data-webinar-actions] [data-webinar][data-property]').on('click', (event) => {
            const $target = jQuery(event.currentTarget);
            const webinarUid = parseInt($target.data('webinar'), 10);
            const property = $target.data('property');

            if (!Number.isFinite(webinarUid) || webinarUid <= 0 || !property) {
                return;
            }

            this.api.increaseWebinarCounter(webinarUid, property);
        });
    }
}
